module.exports = __webpack_public_path__ + "img/ios-folder-open.8e966840.svg";